/* eslint-disable */
import { createApp } from "vue";
import { getAnalytics } from "firebase/analytics";

import "maz-ui/css/main.css";
import "vue-select/dist/vue-select.css";
import App from "./App.vue";
import store from "./store";
import keys from "@/store/keys";
import router from "./router";
import API, { setAppCheckInstance } from "@/store/axios";
import VueGoogleMaps from "@fawmi/vue-google-maps";
import PinInput from "v-pin-input";
import ArgonDashboard from "./argon-dashboard";
import MazPhoneNumberInput from "maz-ui/components/MazPhoneNumberInput";
import LoadScript from "vue-plugin-load-script";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import Toaster from "@meforma/vue-toaster";
import { createVfm } from "vue-final-modal";
const vfm = createVfm();
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { JSEncrypt } from "jsencrypt";
import { Skeletor } from "vue-skeletor";
import ReadMore from "vue-read-more";
import VLazyImage from "v-lazy-image";
import vSelect from "vue-select";
import "./registerServiceWorker";
import VueCleave from "vue-cleave-component";
import Emittery from "emittery";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import "firebase/compat/app-check";

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
};

const hasFirebaseConfig = Boolean(
  firebaseConfig.projectId && firebaseConfig.apiKey && firebaseConfig.appId,
);

if (!hasFirebaseConfig) {
  console.error(
    "[Firebase] Falta configuración. Crea Front-Xtrim/.env.local con las variables VUE_APP_FIREBASE_* (copia desde .env.example o Firebase Console → Project settings).",
  );
}

const appFirebase = firebase.initializeApp(firebaseConfig);

let analytics = null;
if (hasFirebaseConfig) {
  try {
    analytics = getAnalytics(appFirebase);
  } catch (error) {
    console.warn("[Firebase] Analytics no disponible:", error);
  }
}
const auth = firebase.auth();

const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1" ||
  window.location.hostname.includes("localhost");
const isDevelopment = process.env.NODE_ENV === "development" || isLocalhost;

let appCheck = null;
if (!isDevelopment && process.env.VUE_APP_RECAPTCHA_SITE_KEY) {
  try {
    appCheck = initializeAppCheck(appFirebase, {
      provider: new ReCaptchaV3Provider(process.env.VUE_APP_RECAPTCHA_SITE_KEY),
      isTokenAutoRefreshEnabled: true,
    });
    setAppCheckInstance(appCheck);
    console.log("✅ AppCheck inicializado correctamente");
  } catch (error) {
    console.warn(
      "⚠️ Error al inicializar AppCheck, continuando sin AppCheck:",
      error,
    );
    appCheck = null;
  }
} else {
  console.log(
    "⚠️ AppCheck deshabilitado (modo desarrollo/localhost/emulador o sin configuración)",
  );
}

if (isLocalhost) {
  console.log("CONECTADO A EMULADORES (v8 Compat)");
  auth.useEmulator("http://127.0.0.1:9099");

  const db = firebase.firestore();
  db.useEmulator("127.0.0.1", 8082);

  const storage = firebase.storage();
  storage.useEmulator("127.0.0.1", 9199);
}

auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);

const encryptBackoffice = new JSEncrypt();
encryptBackoffice.setPublicKey(keys.publicKeyBackoffice);

const ua = navigator.userAgent;

let isMobile = false;

if (
  /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
    ua,
  )
) {
  //es mobile
  isMobile = true;
} else {
  //es destopk
  isMobile = false;
}

const appInstance = createApp(App);
appInstance.component("MazPhoneNumberInput", MazPhoneNumberInput);
appInstance.config.globalProperties.$appFirebase = appFirebase;

appInstance.config.globalProperties.$analytics = analytics;
appInstance.config.globalProperties.$encryptBackoffice = encryptBackoffice;
appInstance.config.globalProperties.$https = API;
appInstance.config.globalProperties.$isMobile = isMobile;
appInstance.config.globalProperties.$eventBus = new Emittery();
appInstance.use(store);
appInstance.use(router);
appInstance.use(ReadMore);

appInstance.use(VueCleave);
appInstance.use(LoadScript);

appInstance.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    libraries: "places,geocoding",
    v: "weekly",
  },
});
appInstance.component("vue-qrcode", VueQrcode);
appInstance.component("v-select", vSelect);
appInstance.component("v-lazy-image", VLazyImage);
appInstance.component(Skeletor.name, Skeletor);

appInstance.use(VueSweetalert2);
appInstance
  .use(Toaster)
  .provide("toast", appInstance.config.globalProperties.$toast);
appInstance.use(vfm);
appInstance.use(PinInput);

appInstance.use(ArgonDashboard);
appInstance.provide("appCheck", appCheck);
appInstance.provide("https", API); // Provide $https globally
// appInstance.provide("store", store); // Provide $https globally
appInstance.provide("router", router); // Provide $https globally

appInstance.mount("#app");

let deferredPrompt = null;

window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  deferredPrompt = e; // Store globally
});

// Function to trigger the install prompt manually
export function promptPWAInstall() {
  if (deferredPrompt) {
    deferredPrompt.prompt();
    deferredPrompt.userChoice.then((choiceResult) => {
      console.log("User choice:", choiceResult.outcome);
      deferredPrompt = null; // Reset after use
    });
  }
}

export { analytics };
